(function () {
  'use strict';

  var SETTINGS_ENDPOINT = 'https://easysearchapp.dev/settings';
  var SETTINGS_KEY = 'b6bf489c-d47f-404d-9525-475f05236a40';
  var YEAR_SELECTOR = '#easysearch_field_28036';
  var MAKE_SELECTOR = '#easysearch_field_28037';
  var MODEL_SELECTOR = '#easysearch_field_28038';
  var SEARCH_SELECTOR = '#easysearch-search';
  var VEHICLE_PARAMS = ['ppmx_vehicle', 'ppmx_year', 'ppmx_make', 'ppmx_model'];
  var rowsPromise;
  var searching = false;
  var bypassOriginal = false;

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function selectedText(select) {
    if (!select || !select.selectedOptions || !select.selectedOptions.length) return '';
    return select.selectedOptions[0].textContent.trim();
  }

  function parseCsv(text) {
    var rows = [];
    var row = [];
    var value = '';
    var quoted = false;

    for (var index = 0; index < text.length; index += 1) {
      var character = text[index];

      if (character === '"') {
        if (quoted && text[index + 1] === '"') {
          value += '"';
          index += 1;
        } else {
          quoted = !quoted;
        }
      } else if (character === ',' && !quoted) {
        row.push(value);
        value = '';
      } else if ((character === '\n' || character === '\r') && !quoted) {
        if (character === '\r' && text[index + 1] === '\n') index += 1;
        row.push(value);
        if (row.some(function (cell) { return cell !== ''; })) rows.push(row);
        row = [];
        value = '';
      } else {
        value += character;
      }
    }

    if (value !== '' || row.length) {
      row.push(value);
      rows.push(row);
    }

    return rows;
  }

  function findCsvUrl(value, depth) {
    if (depth > 8 || value == null) return '';
    if (typeof value === 'string') {
      var match = value.match(/(?:https?:)?\/\/[^"'\s]+\.csv(?:\?[^"'\s]*)?/i);
      return match ? match[0] : '';
    }
    if (Array.isArray(value)) {
      for (var arrayIndex = 0; arrayIndex < value.length; arrayIndex += 1) {
        var arrayMatch = findCsvUrl(value[arrayIndex], depth + 1);
        if (arrayMatch) return arrayMatch;
      }
      return '';
    }
    if (typeof value === 'object') {
      var keys = Object.keys(value);
      for (var keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
        var objectMatch = findCsvUrl(value[keys[keyIndex]], depth + 1);
        if (objectMatch) return objectMatch;
      }
    }
    return '';
  }

  function fetchWithTimeout(url) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 20000) : null;

    return fetch(url, controller ? { signal: controller.signal, credentials: 'omit' } : { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        return response.text();
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
      });
  }

  function loadRows() {
    if (rowsPromise) return rowsPromise;

    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    var settingsUrl = SETTINGS_ENDPOINT + '?x-api-key=' + encodeURIComponent(SETTINGS_KEY) + '&shop=' + encodeURIComponent(shop);

    rowsPromise = fetchWithTimeout(settingsUrl)
      .then(function (settingsText) {
        var settings;
        try {
          settings = JSON.parse(settingsText);
        } catch (error) {
          settings = settingsText;
        }

        var csvUrl = findCsvUrl(settings, 0);
        if (!csvUrl) throw new Error('EasySearch database URL not found');
        if (csvUrl.indexOf('//') === 0) csvUrl = window.location.protocol + csvUrl;
        return fetchWithTimeout(csvUrl);
      })
      .then(parseCsv)
      .catch(function (error) {
        rowsPromise = null;
        throw error;
      });

    return rowsPromise;
  }

  function yearMatches(specification, selectedYear) {
    var match = String(specification || '').trim().match(/^(\d{4})(?:\s*[-–]\s*(\d{4}))?$/);
    if (!match) return false;
    var start = Number(match[1]);
    var end = Number(match[2] || match[1]);
    var year = Number(selectedYear);
    return year >= Math.min(start, end) && year <= Math.max(start, end);
  }

  function extractTag(row) {
    var source = row.slice(3).join(',');
    var marker = source.indexOf('>>');
    if (marker === -1) return '';
    return source.slice(marker + 2).split('$$$p$$$')[0].trim();
  }

  function tagsForVehicle(rows, year, make, model) {
    var makeKey = normalise(make);
    var modelKey = normalise(model);
    var tags = [];
    var seen = Object.create(null);

    rows.forEach(function (row) {
      if (row.length < 4) return;
      if (!yearMatches(row[0], year)) return;
      if (normalise(row[1]) !== makeKey || normalise(row[2]) !== modelKey) return;

      var tag = extractTag(row);
      if (tag && !seen[tag]) {
        seen[tag] = true;
        tags.push(tag);
      }
    });

    return tags;
  }

  function escapeSearchValue(value) {
    return String(value).replace(/([\\"])/g, '\\$1');
  }

  function buildSearchUrl(selection, tags) {
    var query = tags.map(function (tag) {
      return 'tag:"' + escapeSearchValue(tag) + '"';
    }).join(' OR ');
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('ppmx_vehicle', '1');
    params.set('ppmx_year', selection.year);
    params.set('ppmx_make', selection.make);
    params.set('ppmx_model', selection.model);
    return window.Shopify.routes.root + 'search?' + params.toString();
  }

  function saveSelection(selection, tags) {
    try {
      sessionStorage.setItem('ppmxVehicleSelectionV1', JSON.stringify({
        year: selection.year,
        make: selection.make,
        model: selection.model,
        tags: tags
      }));
    } catch (error) {}
  }

  function useOriginalSearch(button, originalText, originalHref, fallbackSelect) {
    searching = false;
    if (button) {
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    }
    if (originalHref && originalHref.indexOf('javascript:') !== 0 && originalHref !== '#') {
      window.location.assign(originalHref);
    } else if (fallbackSelect) {
      bypassOriginal = true;
      fallbackSelect.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { bypassOriginal = false; }, 0);
    }
  }

  function startVehicleSearch(event, button, fallbackSelect) {
    if (searching) return;
    var yearSelect = document.querySelector(YEAR_SELECTOR);
    var makeSelect = document.querySelector(MAKE_SELECTOR);
    var modelSelect = document.querySelector(MODEL_SELECTOR);
    if (!yearSelect || !makeSelect || !modelSelect) return;

    var selection = {
      year: selectedText(yearSelect),
      make: selectedText(makeSelect),
      model: selectedText(modelSelect)
    };
    if (!yearSelect.value || !makeSelect.value || !modelSelect.value) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    searching = true;

    var originalText = button ? button.textContent : '';
    var originalHref = button ? (button.getAttribute('href') || '') : '';
    if (button) {
      button.textContent = 'Finding all compatible parts…';
      button.setAttribute('aria-busy', 'true');
    }

    loadRows()
      .then(function (rows) {
        var tags = tagsForVehicle(rows, selection.year, selection.make, selection.model);
        if (!tags.length) throw new Error('No compatibility groups found');
        saveSelection(selection, tags);
        window.location.assign(buildSearchUrl(selection, tags));
      })
      .catch(function () {
        useOriginalSearch(button, originalText, originalHref, fallbackSelect);
      });
  }

  function onVehicleSearch(event) {
    var button = event.target.closest(SEARCH_SELECTOR);
    if (!button) return;
    startVehicleSearch(event, button, null);
  }

  function onVehicleModelChange(event) {
    if (bypassOriginal || !event.target.matches(MODEL_SELECTOR) || !event.target.value) return;
    startVehicleSearch(event, document.querySelector(SEARCH_SELECTOR), event.target);
  }

  function ensureWidgetAnchor() {
    var year = document.querySelector(YEAR_SELECTOR);
    if (!year) return;
    var widget = year.closest('form') || year.closest('[class*="easysearch"]') || year.parentElement;
    if (widget === year) widget = year.parentElement;
    if (widget && !document.getElementById('easysearch-app')) widget.id = 'easysearch-app';
    if (window.location.hash === '#easysearch-app' && widget) {
      setTimeout(function () { widget.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
    }
  }

  function appendVehicleParams(form, params) {
    if (!form) return;
    VEHICLE_PARAMS.forEach(function (name) {
      var value = params.get(name);
      if (!value || form.querySelector('input[name="' + name + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
  }

  function appendVehicleParamsToLink(link, params) {
    if (!link || !link.href) return;
    var url = new URL(link.href, window.location.origin);
    VEHICLE_PARAMS.forEach(function (name) {
      var value = params.get(name);
      if (value) url.searchParams.set(name, value);
    });
    link.href = url.toString();
  }

  function decorateSearchResults() {
    var section = document.querySelector('[data-ppmx-search-results]');
    if (!section) return;

    var params = new URLSearchParams(window.location.search);
    if (params.get('ppmx_vehicle') !== '1') return;

    var year = params.get('ppmx_year') || '';
    var make = params.get('ppmx_make') || '';
    var model = params.get('ppmx_model') || '';
    if (!year || !make || !model) return;

    var title = section.querySelector('[data-ppmx-search-title]');
    var eyebrow = section.querySelector('[data-ppmx-search-eyebrow]');
    var description = section.querySelector('[data-ppmx-search-description]');
    var change = section.querySelector('[data-ppmx-change-bike]');

    var vehicle = year + ' ' + make + ' ' + model;
    var titleTemplate = section.getAttribute('data-vehicle-title') || 'Parts for __VEHICLE__';
    if (title) title.textContent = titleTemplate.replace('__VEHICLE__', vehicle);
    if (eyebrow) eyebrow.textContent = section.getAttribute('data-vehicle-eyebrow') || 'Your motorcycle';
    if (description) description.textContent = section.getAttribute('data-vehicle-help') || '';
    if (change) change.hidden = false;
    document.body.classList.add('ppmx-vehicle-results');
    document.title = titleTemplate.replace('__VEHICLE__', vehicle) + ' – ' + (section.getAttribute('data-shop-name') || 'Pro Power MX');

    document.querySelectorAll('#FacetFiltersForm, #PpmxSearchSortForm').forEach(function (form) {
      appendVehicleParams(form, params);
    });
    document.querySelectorAll('.ppmx-search-section .pagination a, .ppmx-search-section .ppmx-facet-link, .ppmx-search-section .active-facets a').forEach(function (link) {
      appendVehicleParamsToLink(link, params);
    });
  }

  document.addEventListener('click', onVehicleSearch, true);
  document.addEventListener('change', onVehicleModelChange, true);
  document.addEventListener('DOMContentLoaded', function () {
    ensureWidgetAnchor();
    decorateSearchResults();
    var results = document.querySelector('[data-ppmx-search-results]');
    if (results) {
      var resultsObserver = new MutationObserver(decorateSearchResults);
      resultsObserver.observe(results, { childList: true, subtree: true });
    }
  });

  var observer = new MutationObserver(ensureWidgetAnchor);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 15000);
})();
